import { isEmpty } from 'lodash';
import { type UseQueryResult, useQuery } from 'react-query';
import {
  CustomerUserApprovalService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_CustomerUserDto,
} from '@wealthlane/api-services/wealthlane-customer-service';
import { resolveTenantScope } from '../../constants/tenantScope';
import { type TableParamsType } from '../../types/common';

const useGetCustomerUserApprovalList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
  // isEnabled?: boolean
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_CustomerUserDto | undefined,
  unknown
> => {
  const {
    approvalStatusId,
    userStatus: isEnabled,
    filter,
    sorting,
    skipCount,
    maxResultCount,
    scope,
    _force,
  } = tableInfo;
  const resolvedScope = resolveTenantScope(scope);

  const getCustomerUserCustomerUserApprovalList = useQuery(
    [
      'getCustomerUserCustomerUserApprovalList',
      approvalStatusId,
      isEnabled,
      resolvedScope,
      filter,
      sorting,
      skipCount,
      maxResultCount,
      _force,
    ],
    async () => {
      return await handleRequest(
        CustomerUserApprovalService.getApiCustomerApiAppCustomerUserApprovalCustomerUserList(
          !isEmpty(approvalStatusId) ? approvalStatusId : [0],
          isEnabled,
          resolvedScope,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
    // {
    //   keepPreviousData: true,
    // }
  );
  return getCustomerUserCustomerUserApprovalList;
};

export default useGetCustomerUserApprovalList;
